import {ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";
import {Compbaser} from "../../../components/compbaser";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {ERROR_CODE, FlickingError, NgxFlickingComponent} from "@egjs/ngx-flicking";
import {faBolt, faEdit, faGlobe, faTv} from '@fortawesome/free-solid-svg-icons';
import {faAndroid, faGoogle, faGooglePlay, faChrome, faApple, faLinux, faMicrosoft, faAmazon} from "@fortawesome/free-brands-svg-icons";
import {TranslocoService} from "@ngneat/transloco";
import {filter} from "rxjs/operators";
import {AuthUserService, StoreSelectorsService} from "../../../services";
import {timeout} from "../../../decorators/timeout";
import {IAppSettingsWrap, IAppStatic} from "../../../interfaces";
import {isNullOrUndef} from '../../../common';
import {Dialog} from "@angular/cdk/dialog";
import {MatDialog} from "@angular/material/dialog";
/**
 *  example: http://localhost:4200/getstarted/downloads/ent/111111111111111  where 11111 is reseller ERI
 *
 * added 6-17-2022 support for:
 * https://galaxy.signage.me/signstudio/getstarted/downloads/ent/111111111111111
 * where 1111111 == reseller ERI base64
 * https://galaxy.signage.me/signstudio/shopping-cart/downloads/ent/eri=f7bee07a7e79c8f1d7951b4d24de4713c22f16&playerParams=157e9b75890c050f9ab8a92fedd7197889ccdf41
 * http://localhost:4200/getstarted/downloads/ent/eri=f7bee07a7e79c8f1d7951b4d24de4713c22f16&playerParams=157e9b75890c050f9ab8a92fedd7197889ccdf41
 * https://galaxy.signage.me/signstudio/shopping-cart/downloads/ent/=f7bee07a7e79c8f1d7951b4d24de4713c22f16&playerParams=157e9b75890c050f9ab8a92fedd7197889ccdf41
 *
 **/

@Component({
    selector: 'app-started-downloads',
    templateUrl: './started-downloads.component.html',
    styleUrls: ['./started-downloads.component.scss'],
    animations: [
        trigger('fadeIn', [
            transition('* => *', [
                style({opacity: 0}),
                animate('300ms ease-in-out')
            ])
        ])
    ]
})

export class StartedDownloadsComponent extends Compbaser {
    coreAppData: IAppSettingsWrap;
    appStatic: IAppStatic;
    showCart = false;
    showPlayer = true;
    showHeader = true;
    showBack = true;
    faTv = faTv;
    faAndroid = faAndroid;
    faGoogle = faGoogle;
    faGooglePlay = faGooglePlay;
    faGlobe = faGlobe;
    faChrome = faChrome;
    faLinux = faLinux;
    faBolt = faBolt;
    faEdit = faEdit;
    faMicrosoft = faMicrosoft;
    faAmazon = faAmazon;
    tabIndex = 0;
    headerText1 = '';
    headerText2 = '';
    plugins = [];
    showLegacyDownloads = false;
    showAdvancedOptions = false;

    @ViewChild(NgxFlickingComponent) flicking: NgxFlickingComponent;
    @ViewChild("installModal", {read: TemplateRef}) installModal: TemplateRef<any>;
    @ViewChild("linuxModal", {read: TemplateRef}) linuxModal: TemplateRef<any>;
    @ViewChild("windowsModal", {read: TemplateRef}) windowsModal: TemplateRef<any>;
    @ViewChild("androidModal", {read: TemplateRef}) androidModal: TemplateRef<any>;
    @ViewChild("raspberryPiModal", {read: TemplateRef}) raspberryPiModal: TemplateRef<any>;

    constructor(private authUserService: AuthUserService,
                private translocoService: TranslocoService,
                private storeSelector: StoreSelectorsService,
                public override dialog: MatDialog,
                public router: Router,
                private route: ActivatedRoute,
                private cdr: ChangeDetectorRef) {
        super();
        const v = this.route.data['value'];
        this.showHeader = v && v.showHeader == false ? v.false : true;
        this.showBack = v && v.showBack == false ? v.false : true;
        this.cod(
            this.storeSelector.getAppSettings()
                .subscribe((i_appSettings: IAppStatic) => {
                    this.appStatic = i_appSettings;
                })
        );
        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => this.coreAppData = i_coreData)
        );
        this.cod(
            this.router.events
                .pipe(
                    filter(event => event instanceof NavigationEnd)
                ).subscribe((event: NavigationEnd) => {
                    if (event.url.indexOf('getstarted') > -1) {
                        this.showCart = true;
                    }
                }
            )
        );
        this.cod(
            this.route.paramMap.subscribe((routeParams) => {
                this.showPlayer = routeParams.get('id') !== 'studio';
                const eri = routeParams.get('eri');
                if (eri) this.applyWhiteLabel(eri);
                this.translateText();
            })
        );
    }

    private applyWhiteLabel(eri: string) {
        // add in the future apply logo / link backs if reseller
        console.log('Enterprise ' + eri);
    }

    async go(val) {
        if (isNullOrUndef(val)) return;

        try {
            await this.flicking.moveTo(val);
            this.tabIndex = parseInt(val);
        } catch (err) {
            if (err instanceof FlickingError) {
                if (err.code === ERROR_CODE.ANIMATION_ALREADY_PLAYING) {
                    // console.log("Animation is already playing!");
                } else if (err.code === ERROR_CODE.ANIMATION_INTERRUPTED) {
                    // console.log("Animation is interrupted by user.");
                }
            }
        }
        // (this.flick as any).moveTo(parseInt(val));
    }

    @timeout(1500)
    translateText() {
        if (this.showPlayer) {
            this.headerText1 = this.translocoService.translate('general.headerText1', {}, this.translocoService.getActiveLang());
            this.headerText2 = this.translocoService.translate('general.headerText21', {}, this.translocoService.getActiveLang());
        } else {
            this.headerText1 = this.translocoService.translate('general.headerText3', {}, this.translocoService.getActiveLang());
            this.headerText2 = this.translocoService.translate('general.headerText4', {}, this.translocoService.getActiveLang());
        }
    }

    goBack() {
        this.authUserService.backToLogin();
    }

    download(value) {
        switch (value) {
            case 'device_compatability': {
                this.dialog.open(this.installModal, {
                    height: '630px',
                    width: '800px'
                });
                return;
            }
            case 'studio_web': {
                if (this?.coreAppData?.[0]?.enterprise) {
                    return window.open(this.coreAppData[1].homePage, '_blank');
                }
                break;
            }
        }
        window.open(this.appStatic[value], '_blank');
    }

    toggleLegacyDownloads() {
        setTimeout(() => {
            this.showLegacyDownloads = !this.showLegacyDownloads;
            this.cdr.markForCheck();
            this.cdr.detectChanges();

            // Scroll to legacy section after animation
            if (this.showLegacyDownloads) {
                setTimeout(() => {
                    const legacySection = document.querySelector('.legacy-section');
                    if (legacySection) {
                        legacySection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                    this.cdr.detectChanges();
                }, 350);
            }
        }, 1);
    }

    toggleAdvancedOptions() {
        setTimeout(() => {
            this.showAdvancedOptions = !this.showAdvancedOptions;
            this.cdr.markForCheck();
            this.cdr.detectChanges();

            if (this.showAdvancedOptions) {
                setTimeout(() => {
                    const advancedSection = document.querySelector('.advanced-section');
                    if (advancedSection) {
                        advancedSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                    this.cdr.detectChanges();
                }, 350);
            }
        }, 1);
    }

    openLinuxModal() {
        this.dialog.open(this.linuxModal, {
            width: '600px',
            maxHeight: '90vh',
            panelClass: 'service-dialog-panel'
        });
    }

    openWindowsModal() {
        this.dialog.open(this.windowsModal, {
            width: '600px',
            maxHeight: '90vh',
            panelClass: 'service-dialog-panel'
        });
    }

    openAndroidModal() {
        this.dialog.open(this.androidModal, {
            width: '600px',
            maxHeight: '90vh',
            panelClass: 'service-dialog-panel'
        });
    }

    openRaspberryPiModal() {
        this.dialog.open(this.raspberryPiModal, {
            width: '600px',
            maxHeight: '90vh',
            panelClass: 'service-dialog-panel'
        });
    }
}
